module.exports = __webpack_public_path__ + "img/aiicon.6b55f5d5.png";